var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    {
      staticClass: "skip-navigation-container",
      attrs: { role: "navigation", "aria-label": "Skip navigation links" },
    },
    _vm._l(_vm.skipLinks, function (link) {
      return _c(
        "a",
        {
          key: link.target,
          staticClass: "skip-navigation",
          attrs: { href: "#" + link.target, "aria-label": link.label },
          on: {
            click: function ($event) {
              return _vm.handleSkipLink(link.target, $event)
            },
          },
        },
        [_vm._v("\n    " + _vm._s(link.text) + "\n  ")]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }